export default __webpack_public_path__ + "static/0281-1c34ef7b1d26613872777c8bab26ff13.png";